export enum SubnavMenuItemId {
  ABOUT = "ABOUT",
  ALL_TOPICS = "ALL_TOPICS",
  BOOKMARKS = "BOOKMARKS",
  COACHMARK_SETTINGS = "COACHMARK_SETTINGS",
  CREATE = "CREATE",
  CUSTOM_MAPS = "CUSTOM_MAPS",
  DISCOVER = "DISCOVER",
  EMBED_MAPS_IN_YOUR_SITE = "EMBED_MAPS_IN_YOUR_SITE",
  FEEDBACK = "FEEDBACK",
  FULLSCREEN = "FULLSCREEN",
  HOME = "HOME",
  LANGUAGE = "LANGUAGE",
  MODERATE = "MODERATE",
  MONITOR = "MONITOR",
  MORE = "MORE",
  RESOURCES = "RESOURCES",
  SOURCES = "SOURCES",
  TERMS = "TERMS",
  THEME = "THEME",
  WHATS_NEW = "WHATS_NEW",
}
